import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { captureRefFromUrl } from "@/lib/affiliate";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("hk_cart") || "[]");
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    captureRefFromUrl();
  }, []);
  useEffect(() => {
    localStorage.setItem("hk_cart", JSON.stringify(items));
  }, [items]);

  const add = (p, plan = null) => {
    setItems((prev) =>
      prev.find((i) => i.id === p.id)
        ? prev
        : [...prev, { id: p.id, title: p.title, price: Number(plan === "yearly" && p.price_yearly ? p.price_yearly : p.price), slug: p.slug, image_url: p.image_url, plan }],
    );
    setOpen(true);
  };
  const remove = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
  const clear = () => setItems([]);
  const has = (id) => items.some((i) => i.id === id);
  const subtotal = items.reduce((s, i) => s + Number(i.price || 0), 0);

  const value = useMemo(
    () => ({ items, count: items.length, subtotal, open, setOpen, add, remove, clear, has }),
    [items, open],
  );
  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export const useCart = () => {
  const c = useContext(CartContext);
  if (!c) throw new Error("useCart must be used within CartProvider");
  return c;
};
